import { css } from "@emotion/core";
import { tokens, shadow, applyFont, media } from "@domain-group/fe-brary";
var typography = tokens.typography,
  shadows = tokens.shadows,
  colors = tokens.colors;
export var divider = /*#__PURE__*/css("border-top:1px solid ", colors.neutral.trim.default, ";", media('>=tablet'), "{border-top:none;}");
export var breadcrumbs = /*#__PURE__*/css("display:flex;white-space:nowrap;", applyFont(typography.mini));
export var breadcrumbsList = /*#__PURE__*/css("overflow-x:auto;overflow-y:hidden;white-space:nowrap;-webkit-overflow-scrolling:touch;", media('>=tablet'), "{overflow-x:hidden;white-space:normal;}");
export var itemList = {
  name: "1baulvz",
  styles: "display:inline-block;"
};
export var item = {
  name: "6n7j50",
  styles: "display:inline;"
};
export var link = function link(isLast) {
  return /*#__PURE__*/css("text-decoration:none;display:inline;color:", colors.neutral.medium.default, ";", media('>=tablet'), "{color:", isLast ? colors.neutral.base.default : colors.neutral.medium.default, ";}", !isLast && /*#__PURE__*/css(":hover{color:", colors.neutral.medium.hover, ";text-shadow:", shadow(shadows.elevation2), ";}"));
};
export var chrevron = /*#__PURE__*/css("color:", colors.neutral.medium.default, ";position:relative;top:-1px;width:16px;height:12px;");
export var back = {
  name: "1baulvz",
  styles: "display:inline-block;"
};
export var separator = /*#__PURE__*/css("width:2px;height:20px;border:none;margin-left:8px;margin-right:8px;", media('>=tablet'), "{border:solid 1px ", colors.neutral.trim.default, ";}");